module.exports = __webpack_public_path__ + "static/img/12016C_R_01_20170816_LC.0552653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12016C_R_01_20170816_LC.png
// module id = DPp+
// module chunks = 0